import Link from 'next/link';

import { ComponentProps as IconProps } from '../../Icon/Icon';

import styles from './ButtonMyPageIndex.module.scss';

import type { FC, ComponentType } from 'react';

type Props = {
  icon: ComponentType<IconProps>;
  title: string;
  readText?: string;
  link?: string;
  useNextLink?: boolean;
};

export const ButtonMyPageIndex: FC<Props> = ({
  icon: Icon,
  title,
  readText,
  link,
  useNextLink,
}) => {
  if (link && useNextLink) {
    return (
      <Link href={link} prefetch={false} legacyBehavior={true}>
        <div className={styles.wrap}>
          <span className={styles['icon-wrap']}>
            <Icon size={18} />
          </span>
          <div className={styles['right-box']}>
            <span className={styles.text}>{title}</span>
            <span className={styles['read-text']}>{readText}</span>
          </div>
        </div>
      </Link>
    );
  }

  return (
    <a className={styles.wrap} href={link}>
      <span className={styles['icon-wrap']}>
        <Icon size={18} />
      </span>
      <div className={styles['right-box']}>
        <span className={styles.text}>{title}</span>
        <span className={styles['read-text']}>{readText}</span>
      </div>
    </a>
  );
};
